import React from 'react';
import { Switch, useLocation } from 'react-router-dom';

import SharedVideosList from '../../components/SharedWithMe/SharedVideos/sharedVideosList';
import SubGroupManagement from '../../components/SubGroupManagementGeneralView';
import MyReflexComposers from '../../components/MyReflexComposers';
import ComposerVideoPage from '../../components/ComposerVideoPage';
import SimpleBreadcrumbs from '../../helpers/simpleBreadcrumbs';
import VideofeedsList from '../../components/VideofeedsList';
import AnalystGroups from '../../components/AnalystGroups';
import SharedWithMe from '../../components/SharedWithMe';
// import SubGroupView from '../../components/SubGroupView (not used)';
import Divider from '../../components/modules/Divider';
import MyFolders from '../../components/MyFolders';
import VideoPage from '../../components/VideoPage';
import UsersList from '../../components/UsersList';
import styles from '../Layout/Layout.module.scss';
import ProtectedRoute from '../ProtectedRoute';
import { PATHS } from '../../enums/PATHS';
import { ROLES } from '../../enums/ROLES';
import Layout from '../Layout';
import Admin from '../../components/Admin';
import AllContentVideofeeds from '../../components/AllContent/AllContentFolder/AllContentVideofeeds/AllContentVideofeeds';
import CollaborativeFolders from '../../components/CollaborativeFolders';
import CollaborativeVideofeedsList from '../../components/CollaborativeVideofeedsList';
import ChildOrgList from '../../components/ChildOrgList';
import OrgGroups from '../../components/OrgGroups';
import ShowWarningModal from '../../components/modules/ShowWarningModal';

const ManagementRoutes = () => {
  const location = useLocation();

  const path = Object.values(PATHS).find((e) => e.path === location.pathname);

  const showNavigation = path && path.breadcrumbs;

  return (
    <Switch>
      <Layout>
        {showNavigation && (
          <>
            <div className="mb-5">
              File Management <Divider />
            </div>

            <div className="mb-5">
              <SimpleBreadcrumbs />
            </div>
          </>
        )}

        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.VIEWER, ROLES.ANALYST]}
          component={MyReflexComposers}
          exact={PATHS.MY_REFLEX_COMPOSERS.exact}
          path={PATHS.MY_REFLEX_COMPOSERS.path}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.VIEWER, ROLES.ANALYST]}
          component={SharedWithMe}
          exact={PATHS.SHARED_WITH_ME.exact}
          path={PATHS.SHARED_WITH_ME.path}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.VIEWER, ROLES.ANALYST]}
          component={MyFolders}
          exact={PATHS.MY_FOLDERS.exact}
          path={PATHS.MY_FOLDERS.path}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST]}
          component={CollaborativeFolders}
          exact={PATHS.COLLABORATIVE_FOLDERS.exact}
          path={PATHS.COLLABORATIVE_FOLDERS.path}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN]}
          component={Admin}
          exact={PATHS.ALL_CONTENT.exact}
          path={PATHS.ALL_CONTENT.path}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN]}
          component={AllContentVideofeeds}
          exact={PATHS.ALL_CONTENT_VIDEOFEEDS.exact}
          path={PATHS.ALL_CONTENT_VIDEOFEEDS.path}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST, ROLES.VIEWER]}
          exact={PATHS.VIDEOFEEDS_LIST.exact}
          path={PATHS.VIDEOFEEDS_LIST.path}
          component={VideofeedsList}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST, ROLES.VIEWER]}
          exact={PATHS.COLLABORATIVE_VIDEOFEEDS_LIST.exact}
          path={PATHS.COLLABORATIVE_VIDEOFEEDS_LIST.path}
          component={CollaborativeVideofeedsList}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST, ROLES.VIEWER]}
          exact={PATHS.TIMELINE.exact}
          path={PATHS.TIMELINE.path}
          component={VideoPage}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST, ROLES.VIEWER]}
          exact={PATHS.COMPOSER_PAGE.exact}
          path={PATHS.COMPOSER_PAGE.path}
          component={ComposerVideoPage}
        />
        <ProtectedRoute
          roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST, ROLES.VIEWER]}
          exact={PATHS.SHARED_VIDEOFEEDS_LIST.exact}
          path={PATHS.SHARED_VIDEOFEEDS_LIST.path}
          component={SharedVideosList}
        />
        <div className={styles.adminView}>
          <div className={styles.container}>
            <ProtectedRoute
              roles={[ROLES.ORGANIZATION_ADMIN]}
              component={UsersList}
              path={PATHS.USERS_LIST.path}
              exact={PATHS.USERS_LIST.exact}
            />
            <ProtectedRoute
              roles={[ROLES.ORGANIZATION_ADMIN]}
              component={ChildOrgList}
              path={PATHS.CHILD_ORG_LIST.path}
              exact={PATHS.CHILD_ORG_LIST.exact}
            />
            <ProtectedRoute
              roles={[ROLES.ANALYST, ROLES.ORGANIZATION_ADMIN, ROLES.VIEWER]}
              component={AnalystGroups}
              path={PATHS.GROUPS_MANAGEMENT.path}
              exact={PATHS.GROUPS_MANAGEMENT.exact}
            />
            <ProtectedRoute
              roles={[ROLES.ORGANIZATION_ADMIN]}
              component={OrgGroups}
              path={PATHS.ORG_GROUPS_MANAGEMENT.path}
              exact={PATHS.ORG_GROUPS_MANAGEMENT.exact}
            />
            <ProtectedRoute
              roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST, ROLES.VIEWER]}
              component={SubGroupManagement}
              path={PATHS.SUB_GROUPS_MANAGEMENT.path}
              exact={PATHS.SUB_GROUPS_MANAGEMENT.exact}
            />
            {/* <ProtectedRoute
              roles={[ROLES.ORGANIZATION_ADMIN, ROLES.ANALYST, ROLES.VIEWER]}
              component={SubGroupView}
              path={PATHS.SUB_GROUP_VIEW.path}
              exact={PATHS.SUB_GROUP_VIEW.exact}
            /> */}
          </div>
          <ShowWarningModal />
        </div>
      </Layout>
    </Switch>
  );
};

export default ManagementRoutes;
